/* Maison Matcha — landing B2B « Les Stories » : logique pure (aucun accès au DOM).
   Navigateur : window.MMB2B · Node : module.exports (tests dans docs/b2b/tests). */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MMB2B = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var NBSP = ' ';
  var DEFAULTS = {
    lattePrice: 5.5, gramsPerDrink: 2,
    cpbSmall: 0.79, cpbMedium: 0.5, cpbLarge: 0.39,
    thresholdMediumG: 500, thresholdLargeG: 5000
  };
  var CONTACT_FIELDS = ['first_name', 'last_name', 'company', 'city', 'phone', 'email'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var MAIL_LABELS = [
    ['type', "Type d'établissement"], ['current', 'Propose déjà du matcha'], ['brand_current', 'Marque actuelle'],
    ['drinks_per_day', 'Boissons par jour'], ['intent', 'Projet'], ['first_name', 'Prénom'], ['last_name', 'Nom'],
    ['company', 'Établissement'], ['city', 'Ville'], ['phone', 'Téléphone'], ['email', 'Email']
  ];

  function parseNum(value, fallback) {
    if (typeof value === 'number') return isFinite(value) ? value : fallback;
    var n = parseFloat(String(value == null ? '' : value).replace(',', '.').replace(/[^\d.\-]/g, ''));
    return isFinite(n) ? n : fallback;
  }

  function text(value) { return String(value == null ? '' : value).trim(); }

  function normalizeConfig(raw) {
    raw = raw || {};
    var cfg = {};
    Object.keys(DEFAULTS).forEach(function (key) {
      var v = parseNum(raw[key], DEFAULTS[key]);
      cfg[key] = v > 0 ? v : DEFAULTS[key];
    });
    return cfg;
  }

  function tier(drinksPerDay, cfg) {
    cfg = cfg || DEFAULTS;
    var n = Math.max(0, Math.round(parseNum(drinksPerDay, 0)));
    var grams = n * 30 * cfg.gramsPerDrink;
    var format, cost;
    if (grams < cfg.thresholdMediumG) { format = 'Sachet 200 g'; cost = cfg.cpbSmall; }
    else if (grams < cfg.thresholdLargeG) { format = 'Sachet 1 kg'; cost = cfg.cpbMedium; }
    else { format = '5 kg et plus'; cost = cfg.cpbLarge; }
    return { drinksPerDay: n, gramsPerMonth: grams, format: format, costPerDrink: cost, share: cost / cfg.lattePrice };
  }

  function formatEur(value) { return parseNum(value, 0).toFixed(2).replace('.', ',') + NBSP + '€'; }

  function formatVolume(grams) {
    grams = Math.max(0, Math.round(parseNum(grams, 0)));
    if (grams < 1000) return grams + NBSP + 'g / mois';
    return (grams / 1000).toFixed(1).replace('.', ',') + NBSP + 'kg / mois';
  }

  function formatShare(share) { return Math.round(parseNum(share, 0) * 100) + NBSP + '%'; }

  function validateContact(fields) {
    fields = fields || {};
    var errors = {};
    CONTACT_FIELDS.forEach(function (name) {
      var v = text(fields[name]);
      if (!v) { errors[name] = 'required'; return; }
      if (name === 'email' && !EMAIL_RE.test(v)) errors[name] = 'invalid';
      if (name === 'phone' && v.replace(/\D/g, '').length < 9) errors[name] = 'invalid';
    });
    return { ok: Object.keys(errors).length === 0, errors: errors };
  }

  function readUtm(search) {
    var out = {};
    var params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
    UTM_KEYS.forEach(function (key) { var v = params.get(key); if (v) out[key] = v.slice(0, 200); });
    return out;
  }

  function buildPayload(state, utm, ctx) {
    state = state || {}; utm = utm || {}; ctx = ctx || {};
    var hasDrinks = state.drinks_per_day !== '' && state.drinks_per_day != null;
    var t = hasDrinks ? tier(state.drinks_per_day, normalizeConfig(ctx.config)) : null;
    var payload = {
      type: text(state.type),
      current: text(state.current),
      brand_current: state.current === 'Oui' ? text(state.brand_current) : '',
      drinks_per_day: t ? t.drinksPerDay : '',
      volume_kg_month: t ? Math.round(t.gramsPerMonth / 100) / 10 : '',
      intent: text(state.intent),
      first_name: text(state.first_name),
      last_name: text(state.last_name),
      company: text(state.company),
      city: text(state.city),
      phone: text(state.phone),
      email: text(state.email),
      page_url: text(ctx.pageUrl),
      referrer: text(ctx.referrer),
      hp: text(state.hp),
      elapsed_ms: Math.max(0, Math.round(parseNum(ctx.elapsedMs, 0)))
    };
    UTM_KEYS.forEach(function (key) { payload[key] = text(utm[key]); });
    return payload;
  }

  function mailtoHref(to, payload) {
    payload = payload || {};
    var lines = MAIL_LABELS
      .filter(function (l) { return text(payload[l[0]]) !== ''; })
      .map(function (l) { return l[1] + ' : ' + payload[l[0]]; });
    var subject = 'Demande professionnelle — ' + (text(payload.company) || 'Maison Matcha');
    var body = 'Bonjour,\n\nJe souhaite être recontacté(e) au sujet de votre matcha pour les professionnels.\n\n' + lines.join('\n');
    return 'mailto:' + text(to) + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  /* Correspondance avancée Meta : coordonnées du lead au format attendu par le pixel, qui les hache (SHA-256)
     dans le navigateur avant envoi. Téléphone en chiffres avec l'indicatif, sans « + » ; France par défaut. */
  function matchData(payload) {
    payload = payload || {};
    var out = { country: 'fr' };
    var em = text(payload.email).toLowerCase();
    if (EMAIL_RE.test(em)) out.em = em;
    var raw = text(payload.phone);
    var ph = raw.replace(/\D/g, '');
    if (raw.charAt(0) !== '+') {
      if (/^00/.test(ph)) ph = ph.slice(2);
      else if (/^0\d{9}$/.test(ph)) ph = '33' + ph.slice(1);
      else if (/^\d{9}$/.test(ph)) ph = '33' + ph;
    }
    if (ph.length >= 10) out.ph = ph;
    var fn = text(payload.first_name).toLowerCase();
    var ln = text(payload.last_name).toLowerCase();
    if (fn) out.fn = fn;
    if (ln) out.ln = ln;
    return out;
  }

  return {
    DEFAULTS: DEFAULTS, CONTACT_FIELDS: CONTACT_FIELDS, UTM_KEYS: UTM_KEYS,
    parseNum: parseNum, normalizeConfig: normalizeConfig, tier: tier,
    formatEur: formatEur, formatVolume: formatVolume, formatShare: formatShare,
    validateContact: validateContact, readUtm: readUtm, buildPayload: buildPayload, mailtoHref: mailtoHref,
    matchData: matchData
  };
});
